import React, {FC, useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../../../../store/store";
import {Loader} from "../../../../components/UI/Loader/Loader";
import {PlaneCard} from "../../../Lk/OperatorsOnly/Fleet/components/PlaneCard";
import {InitialPage} from "../../../../utils/constans/pagination/pagination";
import {
  clearPlaneApprovalList,
  getPlaneApprovalList
} from "../../../../store/reducers/fleetReducer/fleetReducer";
import {IPlane} from "../../../../store/reducers/fleetReducer/fleetReducerTypes";
import styled from "styled-components";
import {useIntl} from "react-intl";
import {CommonFormMessages} from "../../../../intl/commonMessages/CommonFormMessages";
import {CustomButton} from "../../../../components/UI/AntCustom/CustomButton";
import {CustomSearch} from "../../../../components/UI/AntCustom/CustomSearch";
import {mediaScreenSizes} from "../../../../utils/constans/styles/screenSizes";

const PlaneApprovalList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  
  @media(max-width: ${mediaScreenSizes.mobile}) {
    grid-template-columns: repeat(auto-fill, minmax(266px, 1fr));
  }
`;

interface IPlaneApprovalTabPane {
  isPending: boolean;
}

export const PlaneApprovalTabPane: FC<IPlaneApprovalTabPane> = ({isPending}) => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(InitialPage);
  const {
    isLoading,
    items,
    totalCount
  } = useAppSelector(state => state.fleet.approvalList || {isLoading: false, items: [], totalCount: 0});

  useEffect(() => {
    dispatch(getPlaneApprovalList({
      isPending: isPending,
      page: InitialPage,
    }));

    setCurrentPage(InitialPage);

    return () => {
      dispatch(clearPlaneApprovalList());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPending])

  const search = () => {
    dispatch(getPlaneApprovalList({
      isPending: isPending,
      page: InitialPage,
    }));

    setCurrentPage(InitialPage);
  }

  const loadMore = () => {
    dispatch(getPlaneApprovalList({
      isPending: isPending,
      page: currentPage + 1,
    }));

    setCurrentPage(prev => prev + 1);
  }

  return (
    <>
      <CustomSearch
        placeholder={intl.formatMessage(CommonFormMessages.searchPlaceholder)}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        loading={isLoading}
        onSearch={search}
      />

      {items.length === 0 && isLoading ? <Loader/> :
        <PlaneApprovalList>
          {items.map((p: IPlane) => <PlaneCard
            key={p.id}
            plane={p}
            isAdmin={true}
            isPending={isPending}
          />)}
        </PlaneApprovalList>
      }

      {items.length > 0 && totalCount > items.length &&
        <CustomButton
          loading={isLoading}
          type={"primary"}
          onClick={loadMore}>
          {intl.formatMessage(CommonFormMessages.showMore)}
        </CustomButton>}
    </>
  );
};

